import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-white" aria-labelledby="dolor-titulo" data-id="element-94" data-mp="2lm0v5d9i1cv3">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:px-6 sm:py-16" data-id="element-95" data-mp="26z7o0va4vddz">
        <div className="mx-auto max-w-3xl text-center" data-id="element-96" data-mp="2bxiyn8895rx9">
          <h2 id="dolor-titulo" className="font-display text-[1.6rem] leading-[1.05] text-ink-strong sm:text-4xl" data-id="element-97" data-mp="2bvy2xfa7c2xt">
            Tu Airbnb no es una cárcel: no debería depender de vos 24/7
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink sm:text-base" data-id="element-98" data-mp="21x08jvq3hf6w">
            Si cada huésped necesita que vos le expliques cómo entrar, dónde
            está el wifi o qué hacer si algo falla, tu propiedad todavía no está
            sistematizada. Y el peor momento siempre llega igual: el mensaje de
            las 2 a.m. que no sabés cómo responder sin arriesgar la reseña.
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-3 lg:grid-cols-3" data-id="element-99" data-mp="1z0exkpa70w3q">
          {painPoints.map(point => <li key={point} className="flex items-start gap-2.5 rounded-lg border border-brand-border bg-brand-soft px-3.5 py-3" data-id="element-100" data-mp="1u0smaldxdpxk">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand text-white" data-id="element-101" data-mp="23qvg2nsvf7wy">
                <XIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="1g2lxduqyf0a1" />
              </span>
              <span className="text-[13px] font-medium leading-snug text-ink sm:text-sm" data-id="element-103" data-mp="1b417ao5f1wzb">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="font-display mx-auto mt-8 max-w-2xl text-center text-xl leading-tight text-ink-strong sm:text-2xl" data-id="element-104" data-mp="1k2wbjuowgwzz">
          El problema no es tu propiedad.
          <span className="mt-1 block text-brand" data-id="element-105" data-mp="30jh6bapmm2bh">
            El problema es que todavía no tenés un sistema.
          </span>
        </p>
      </div>
    </section>;
}